import { ReactElement, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../controls/Button';

/**
 * Register Device Component for Account Activation.
 * @returns - Recat component for RegisterDeviceComponent UI.
 */
export default function RegisterDeviceComponent(): ReactElement {
  // const [macAddress, setMacAddress] = useState('');
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  /**
   * Handles the onActivate action.
   */
  const onActivate = (): void => {
    navigate('/auth/user-details');
  };

  return (
    <div className="flex flex-col gap-8 w-full">
      <div className="text-3xl font-bold dark:text-white text-black text-center">
        Welcome to TelosAir
      </div>
      {/* <div className="text-gray-400 mt-1">Start managing your devices for free</div> */}
      <div className="dark:bg-container-700 bg-white p-6 rounded w-full">
        <div className="text-xl dark:text-white text-black font-semibold">Register Devices</div>
        <div className="text-gray-400 mt-1">
          Enter the MAC Address of the device to start setting up your dashboard
        </div>
        <div className="mt-8 flex items-center flex-1 gap-2">
          {/* <InputBox
            name="mac-address"
            id="mac-address"
            noMarginTop
            textValue={macAddress}
            setText={setMacAddress}
          /> */}
          <div className="w-36">
            <Button isBlockButton onClick={onActivate} theme="primary" size="sm" name="Activate" />
          </div>
        </div>
        <div className="text-gray-500 text-base mt-6">
          If you need help finding the UDID{' '}
          <span className="text-primary-500 cursor-pointer">Click here</span>
        </div>
        <div className="flex items-center gap-10 mt-48">
          <div className="text-gray-500 font-medium">Trouble Activating?</div>
          <div className="w-40">
            <Button isBlockButton size="sm" theme="secondary-color" name="Contact Support" />
          </div>
        </div>
      </div>
      <div className="flex justify-center items-center flex-row gap-3">
        <div className="font-medium text-gray-500">Have an account?</div>
        <div className="w-40">
          <Button
            onClick={() => navigate('/auth/login')}
            isBlockButton
            size="sm"
            theme="secondary-gray"
            name="Sign In"
          />
        </div>
      </div>
    </div>
  );
}
